// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a184b479","455":"327f5c65"}[chunkId] + ".chunk.js";
};